<template>
  <div class="lib__form__fieldset-group">
    <fieldset class="lib__form__fieldset">
      <legend class="lib__form__legend">{{ $t('contact.form.civility') }}</legend>
      <civility-selector :data-vv-as="$t('contact.form.civility')" name="civility" v-model="value.civility"></civility-selector>
    </fieldset>
    <fieldset class="lib__form__fieldset">
      <legend class="lib__form__legend">{{ $t('contact.form.contactInformation') }}</legend>

      <div class="row">
        <div class="col-xs-12 col-md-6">
          <text-box :label="$t('contact.form.firstname')" data-cy="contact-form-firstname" required v-model="value.firstname" :rules="{ name_valid_characters: true }"></text-box>
        </div>
        <div class="col-xs-12 col-md-6">
          <text-box :label="$t('contact.form.lastname')" data-cy="contact-form-lastname" required v-model="value.lastname" :rules="{ name_valid_characters: true }"></text-box>
        </div>
        <div class="col-xs-12 col-md-6">
          <text-box :label="$t('contact.form.email')" :labelTooltip="emailTooltip" data-cy="contact-form-email" email required v-model="emailAddress"></text-box>
        </div>
        <div class="col-xs-12 col-md-6">
          <date-selector :label="$t('contact.form.birthDate')" v-if='showBirthdate' data-cy="contact-form-birthdate" required v-model="value.birthDate"></date-selector>
        </div>
        <div class="col-xs-12 col-md-6">
          <phone-box :label="$t('contact.form.mobile')" :required="!value.phone || value.phone === '+32 '" :labelTooltip="mobileTooltip" data-cy="contact-form-mobile" gsm v-model="value.mobile"></phone-box>
        </div>
        <div class="col-xs-12 col-md-6">
          <collapsable-phone-box :label="$t('contact.form.phone')" :addLabel="$t('contact.addPhone')" :required="!value.mobile || value.mobile === '+32 '" :labelTooltip="phoneTooltip" data-cy="contact-form-phone" v-model="value.phone">
          </collapsable-phone-box>
        </div>
      </div>
    </fieldset>

    <fieldset class="lib__form__fieldset" v-if="ibanRequired">
      <legend class="lib__form__legend">
        {{ $t('contact.form.bankAccountInformation') }}
        <sup class="lib__tooltips lib__tooltips--large" style="margin-left: 5px">
          <span class="lib__tooltips__trigger">
            <i class="fas fa-info"></i>
          </span>
          <span class="lib__tooltips__data">{{ $t('contact.form.bankAccountInformationMessage') }}</span>
        </sup>
      </legend>

      <ContactIbanInfos :required=ibanRequired :with-holder-name=withIbanHolderName v-model=value />
    </fieldset>
  </div>
</template>

<script lang="ts">
import { Component, Prop } from 'vue-property-decorator'
import { ContactIndividual } from '@/models'
import ContactBaseForm from './ContactBaseForm'
import ContactIbanInfos from '@/components/inputs/Contact/ContactIbanInfos.vue'

@Component({
  components: { ContactIbanInfos }
})
export default class ContactIndividualForm extends ContactBaseForm {
  //#region [Property]
  @Prop({ type: Object, required: true }) public readonly value!: ContactIndividual
  @Prop({ type: Boolean, required: false, default: false }) public readonly ibanRequired!: boolean
  @Prop({ type: Boolean, required: false, default: true }) public readonly showBirthdate!: boolean
  @Prop({ type: Boolean, required: false, default: false }) public readonly withIbanHolderName!: boolean
  //#endregion

  //#region [Data]
  //#endregion

  //#region [Computed]
  protected get emailAddress(): string | null {
    return this.value.email
  }
  protected set emailAddress(value: string | null) {
    this.value.email = value?.trim() ?? null
  }
  //#endregion

  //#region [Method]
  //#endregion
}
</script>
